/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var o = function o(t) {
    for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      e[_key - 1] = arguments[_key];
    }
    return {
      strTag: !0,
      strings: t,
      values: e
    };
  },
  c = o,
  a = function a(t) {
    return typeof t != "string" && "strTag" in t;
  },
  g = function g(t, e, s) {
    var n = t[0];
    for (var r = 1; r < t.length; r++) n += e[r - 1], n += t[r];
    return n;
  };
export { a as isStrTagged, g as joinStringsAndValues, c as str };